module.exports = __webpack_public_path__ + "img/Billedbog_Rim_og_regler2.ecf4e6ba.jpg";